export default "__VITE_ASSET__cc9a8d77__"